<template>
  <div class="single-element-wrapper">
    <h3 class="single-element-heading">
        Education #{{ index + 1 }}
      {{ institution.length !== 0 ? `- ${institution}` : "" }}
    </h3>
    <TextInput
      name="institution"
      labelText="Educational institution"
      placeholder="Enter the name "
      v-model="institution"
      :validationMessage="errorMessages.institution"
    />
    <TextInput
      name="faculty"
      labelText="Faculty"
      placeholder="Enter the faculty where you studied"
      v-model="faculty"
      :validationMessage="errorMessages.faculty"
    />
    <TextInput
      name="specialty"
      labelText="Speciality"
      placeholder="Indicate your specialty"
      v-model="specialty"
      :validationMessage="errorMessages.specialty"
    />
    <div class="dates-wrapper">
      <UniversalMonthPicker
        labelText="Start date"
        placeholder="Choose date"
        v-model="beginDate"
      />
      <UniversalMonthPicker
        labelText="End date"
        placeholder="Choose date"
        v-model="endDate"
      />
    </div>
    <div class="remove-button" @click="handleModelRemove">
        Delete education
    </div>
  </div>
</template>

<script>
import TextInput from "../utility/TextInput";
import UniversalMonthPicker from "../utility/UniversalMonthPicker";

import useVuelidate from "@vuelidate/core";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { helpers, maxLength } from "@vuelidate/validators";
import { noDigits } from "../../validations/custom";

export default {
  name: "SingleCourse",
  props: {
    id: String,
    index: {
      type: Number,
      default: 0,
    },
    educationTitle: {
      type: String,
      default: "",
    },
    educationFaculty: {
      type: String,
      default: "",
    },
    educationSpecialty: {
      type: String,
      default: "",
    },
    educationBeginDate: {
      type: String,
      default: "",
    },
    educationEndDate: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "modelRemove"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      institution: this.educationTitle,
      faculty: this.educationFaculty,
      specialty: this.educationSpecialty,
      beginDate: this.educationBeginDate,
      endDate: this.educationEndDate,
    };
  },
  computed: {
    educationModel: function () {
      return {
        id: this.id,
        institution: this.institution,
        faculty: this.faculty,
        specialty: this.specialty,
        beginDate: this.beginDate,
        endDate: this.endDate,
      };
    },
    errorMessages: function () {
      return {
        institution: getErrorMessage(this.v$.institution.$errors),
        faculty: getErrorMessage(this.v$.faculty.$errors),
        specialty: getErrorMessage(this.v$.specialty.$errors),
      };
    },
  },
  watch: {
    educationModel: function () {
      this.handleModelChange();
    },
  },
  methods: {
    handleModelChange() {
      const payload = {
        type: "education",
        value: this.educationModel,
      };

      this.$emit("update:modelValue", payload);
    },
    handleModelRemove() {
      const payload = {
        type: "education",
        id: this.id,
      };

      this.$emit("modelRemove", payload);
    },
  },
  components: {
    TextInput,
    UniversalMonthPicker,
  },
  validations() {
    return {
      institution: {
        maxLength: maxLength(50),
        $autoDirty: true,
      },
      faculty: {
        noDigits: helpers.withMessage("Digits are not allowed", noDigits),
        maxLength: maxLength(50),
        $autoDirty: true,
      },
      specialty: {
        noDigits: helpers.withMessage("Digits are not allowed", noDigits),
        maxLength: maxLength(50),
        $autoDirty: true,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/single-element-card";
</style>
